import DefaultDashboardPage from './DefaultDashboardPage'

export const DashboardRoutes = [{ path: '', element: <DefaultDashboardPage /> }]
